import BaseClient from './BaseClient';

class MessagesClient extends BaseClient {
    /** Messages contacts operations */
    messagesGetContacts($contactId, params) {
        const method = 'get';
        const url = `/api/messages/contacts/${$contactId}`;

        return this.makeCoreApiRequest(url, method, null, params);
    }

    create(data) {
        const url = '/api/messages';
        return this.makeCoreApiRequest(url, 'post', data);
    }

    listMessages(teamId, contactId, params, config = {}) {
        const url = `/api/v3/teams/${teamId}/contacts/${contactId}/messages`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    listMessagesUsingLink(link) {
        return this.makeCoreApiRequest(link);
    }

    createV3(teamId, data) {
        const url = `/api/v3/teams/${teamId}/messages`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    sendTestMessages(teamId, data) {
        const url = `/api/v3/teams/${teamId}/messages/test`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    groupMessageCreate(teamId, groupId, data) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/messages`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    groupSendTestMessages(teamId, groupId, data) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/messages/test`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    orgUnitSendTestMessages(teamId, orgUnitId, data) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/messages/test`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    groupListMessages(teamId, groupId, contactId, params, config = {}) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/contacts/${contactId}/messages`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getPhoneNumber(teamId, params) {
        const url = `/api/v3/teams/${teamId}/messages/phone-number`;
        return this.makeCoreApiRequest(url, 'get', params);
    }

    getGroupPhoneNumber(teamId, groupId, params) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/messages/phone-number`;

        return this.makeCoreApiRequest(url, 'get', params);
    }
}

export default new MessagesClient();
